import { render, staticRenderFns } from "./GeradorSenha.vue?vue&type=template&id=0a4c8e73&"
import script from "./GeradorSenha.vue?vue&type=script&lang=js&"
export * from "./GeradorSenha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports